<template>
  <v-card>
    <v-layout row wrap>
      <v-flex xs12 xl12>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      context: 'dashboard context'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue